import { gql } from '@apollo/client';

export const SET_USER_VIP_STATUS_MUTATION = gql`
  mutation SetUserVipStatus($userId: ID!, $enabled: Boolean!) {
    setUserVipStatus(userId: $userId, enabled: $enabled) {
      id
      hasVipAccess
      premiumAccess {
        isPremium
        sources
        expiresAt
      }
    }
  }
`;
